module.exports = __webpack_public_path__ + "img/workflowz.a5b08514.svg";